// Below this, the running clock is shown as low on time.
export const CLOCK_LOW_TIME_MS = 30_000;

export type Seat = "player1" | "player2";

// The players' clocks in a live game. The server keeps the time; clients only display it.
export interface GameClock {
    // Time each player started the game with.
    initialMs: number;
    // Time left for each player. For the player whose turn it is, at turnStartedAt.
    player1Ms: number;
    player2Ms: number;
    // Server time (epoch milliseconds) when the running clock started; undefined when no clock runs.
    turnStartedAt?: number;
}

export interface ClockTimes {
    player1Ms: number;
    player2Ms: number;
}
